import { BoxProps, TextProps } from '@jfs/ui-new'

export const styles = {
  resendContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,

  resendTouchable: {
    alignSelf: 'center',
    width: 180,
    marginTop: 8,
    zIndex: 9999,
  } as BoxProps,

  countStyle: {
    fontSize: 12,
    width: 16,
    marginStart: 4,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_75',
  } as TextProps,

  secondStyle: {
    fontSize: 12,
    color: 'BLACK_75',
    fontFamily: 'jiotype-medium',
  } as TextProps,
}
